import React from 'react';
import { Footer } from 'app/modules/web-shop/components/footer';
import { OneStopBlock } from 'app/modules/web-shop/sub-modules/landing-module/components/our-shop-block';
import { LandingHeader } from 'app/modules/web-shop/sub-modules/landing-module/components/landing-header';
import { Testimonials } from 'app/modules/web-shop/sub-modules/landing-module/components/testimonials-block';
import { AidProfessional } from 'app/modules/web-shop/sub-modules/landing-module/components/aid-professionals-block';
import UncoverDataBlock from './components/UncoverData-block';
import SneakPeekBlock from './components/sneak-peak-block';

export function LandingModule() {
  return (
    <React.Fragment>
      <LandingHeader />
      <SneakPeekBlock />
      <OneStopBlock />
      <AidProfessional />
      <UncoverDataBlock />
      <Testimonials />
      <Footer />
    </React.Fragment>
  );
}
